import { createAction, props } from '@ngrx/store';
import { IFederatedLoginResponse } from '../../../models';

export const LoadFederatedLoginData = createAction(
  '[Login] Load LoginData',
  props<{
    email: string;
    nonce: string;
    state: string;
    redirectUri: string;
    isWeb?: boolean;
    loginSource?: 'WEB' | 'MOBILE';
  }>()
);

export const LoadFederatedLoginDataSuccess = createAction(
  '[Login] Load LoginData Success',
  props<{ federatedLoginData: IFederatedLoginResponse }>()
);
export const LoadFederatedLoginDataFailed = createAction(
  '[Login] Load LoginData Failed',
  props<{ error: Error }>()
);

export const ResendVerifyEmail = createAction('[Login] Resend Verify Email');

export const ResendVerifyEmailSuccess = createAction('[Login] Resend Verify Email Success');

export const ResendVerifyEmailFailed = createAction(
  '[Login] Resend Verify Email Failed',
  props<{ error: Error }>()
);

export type LogoutReason = 'auth' | 'unauthorized' | 'downtime';

/**
 * `reason` selects the screen the user lands on after the logout.
 *
 * `userInitiated` separates the logouts the user asked for (settings screen,
 * account deletion) from the ones the app performs on its own when a session
 * turns out to be dead. Only a user-initiated logout unregisters the device
 * from push notifications: an expiring session must not silently cost the user
 * their notifications, because nothing tells them it happened. ART-19930
 */
export const RequestLogout = createAction(
  '[Auth] Request Logout',
  props<{ reason?: LogoutReason; userInitiated?: boolean }>()
);
